<template>
  <div>
    <button @click="archiveShow = !archiveShow" class="col-12 p2 outlined-dark-button h5 gibson mb0 not-rounded">
      <span class="regular">Se listen</span>
    </button>
    <!-- Modal Component -->
    <b-modal lazy centered hide-header-close id="modal-center" ref="archiveModal" lazy v-model="archiveShow">
      <div class="clearfix p2">
        <div slot="modal-title" class="flex justify-between items-center">
          <div>
            <p class="h5 darkblue m0 gibson line-height-3">
              Archived kundehenvendelser
              <!-- Tidligere opgaver på markedspladsen<br>(2 måneder siden) -->
            </p>
          </div>
          <div>
            <button @click="closeArchiveModal" class="outlined-delete-button p1">
              <span><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-6 -6 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-close"><path d='M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z' /></svg></span>
            </button>
          </div>
        </div>
      </div>
      <div class="clearfix px2">
        <marketarchive></marketarchive>
      </div>
      <!-- modalFooter -->
      <div slot="modal-footer">
        <div class="clearfix px2 py3">
          <div class="flex justify-end">
            <button type="reset" slot="modal-cancel" @click="closeArchiveModal" class="col-12 h5 standard-button p2 gibson border-none not-rounded">
              <span>Luk</span>
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import marketarchive from './../MarketArchive'
export default {
  name: 'archivemodal',
  components: {
    marketarchive
  },
  data () {
    return {
      archiveShow: false
    }
  },
  methods: {
    closeArchiveModal () {
      this.$refs.archiveModal.hide()
    }
  }
}
</script>
<style scoped>
.modal-header,
.modal-footer,
.modal-content {
  border-top: 0;
  border-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// ArchiveModal.vue?6027d37b